import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'application/store';

import { FeatureFlagsState } from './types';

export const selectFeatureFlagsState = (state: RootState): FeatureFlagsState => state.featureFlags;

/* Runtime Feature Flags */
export const selectRuntimeFeatureFlags = createSelector(
  [selectFeatureFlagsState],
  (featureFlags) => featureFlags.runtimeFlags
);

export const selectIsBillingEnabledFeatureFlag = createSelector([selectRuntimeFeatureFlags], (runtimeFeatureFlags) =>
  Boolean(runtimeFeatureFlags.isBillingEnabled)
);

export const selectIsCertLetterAvailable = createSelector([selectRuntimeFeatureFlags], (runtimeFeatureFlags) =>
  Boolean(runtimeFeatureFlags.isCertLetterAvailable)
);

export const selectIsVideoAvailable = createSelector([selectRuntimeFeatureFlags], (runtimeFeatureFlags) =>
  Boolean(runtimeFeatureFlags.isVideoAvailable)
);

export const selectIsShowReports = createSelector([selectRuntimeFeatureFlags], (runtimeFeatureFlags) =>
  Boolean(runtimeFeatureFlags.isShowReports)
);

export const selectIsOffertaChanged = createSelector([selectRuntimeFeatureFlags], (runtimeFeatureFlags) =>
  Boolean(runtimeFeatureFlags.isOffertaChanged)
);

export const selectIsInstantAdcampaignAvailable = createSelector([selectRuntimeFeatureFlags], (runtimeFeatureFlags) =>
  Boolean(runtimeFeatureFlags.isInstantAdcampaignAvailable)
);

export const selectIsChangePricePlanAvailable = createSelector([selectRuntimeFeatureFlags], (runtimeFeatureFlags) =>
  Boolean(runtimeFeatureFlags.isChangePricePlanAvailable)
);

export const selectIsBusinessProfileAvailable = createSelector([selectRuntimeFeatureFlags], (runtimeFeatureFlags) =>
  Boolean(runtimeFeatureFlags.isBusinessProfileAvailable)
);

export const selectIsAddressesGroupsAvailable = createSelector([selectRuntimeFeatureFlags], (runtimeFeatureFlags) =>
  Boolean(runtimeFeatureFlags.isAddressesGroupsAvailable)
);

export const selectIsVideoAdsAvailable = createSelector([selectRuntimeFeatureFlags], (runtimeFeatureFlags) =>
  Boolean(runtimeFeatureFlags.isVideoAdsAvailable)
);

export const selectShowNewPaymentSchemeBanner = createSelector([selectRuntimeFeatureFlags], (runtimeFeatureFlags) =>
  Boolean(runtimeFeatureFlags.showNewPaymentSchemeBanner)
);

/* Build Feature Flags */
export const selectBuildFeatureFlags = createSelector(
  [selectFeatureFlagsState],
  (featureFlags) => featureFlags.buildFlags
);

export const selectIsFeatureShelfPage = createSelector([selectBuildFeatureFlags], (buildFeatureFlags) =>
  Boolean(buildFeatureFlags.isFeatureShelfPage)
);

export const selectShowCaptcha = createSelector([selectBuildFeatureFlags], (buildFeatureFlags) =>
  Boolean(buildFeatureFlags.showCaptcha)
);

export const selectNewPointAdList = createSelector([selectBuildFeatureFlags], (buildFeatureFlags) =>
  Boolean(buildFeatureFlags.newPointAdList)
);

export const selectShowContactWithManagerButton = createSelector([selectBuildFeatureFlags], (buildFeatureFlags) =>
  Boolean(buildFeatureFlags.showContactWithManagerButton)
);

export const selectIsFeatureSubCollections = createSelector([selectBuildFeatureFlags], (buildFeatureFlags) =>
  Boolean(buildFeatureFlags.isFeatureSubCollections)
);

export const selectWithBroadcastSchedule = createSelector([selectBuildFeatureFlags], (buildFeatureFlags) =>
  Boolean(buildFeatureFlags.withBroadcastSchedule)
);
